/**
 * Anne at Home Finish Picker
 *
 * Renders as: single inline "Finish: <NAME>" heading + a grid of small
 * circular swatches with no per-swatch labels (matches the native
 * variant picker UX).
 *
 *  - Hover a swatch → heading updates to preview that finish's name
 *  - Mouse leaves the swatch → heading reverts to the currently-selected finish
 *  - Click a swatch → commits the selection (updates heading + hidden input)
 *  - Keyboard focus/blur behaves like hover
 *
 * The hidden `properties[Finish]` input is server-pre-populated with the
 * first finish's label so submissions work even without JS.
 */
(function () {
  'use strict';

  function setActiveLabel(picker, text) {
    var label = picker.querySelector('[data-aah-active-label]');
    if (label) label.textContent = text;
  }

  function getSelectedLabel(picker) {
    return picker.getAttribute('data-aah-selected-label') ||
           (picker.querySelector('[data-aah-finish-option].is-selected') || {}).dataset?.finishLabel ||
           '';
  }

  // Click → commit selection
  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-aah-finish-option]');
    if (!option) return;
    var picker = option.closest('[data-aah-finish-picker]');
    if (!picker) return;
    var input = picker.querySelector('[data-aah-finish-input]');
    if (!input) return;

    var newLabel = option.dataset.finishLabel || '';
    picker.querySelectorAll('[data-aah-finish-option]').forEach(function (s) {
      var on = s === option;
      s.classList.toggle('is-selected', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Persist selection (used by hover-revert below) + update form input
    picker.setAttribute('data-aah-selected-label', newLabel);
    setActiveLabel(picker, newLabel);
    input.value = newLabel;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Hover (or keyboard focus) → preview the finish name in the heading
  function previewOn(event) {
    var option = event.target.closest('[data-aah-finish-option]');
    if (!option) return;
    var picker = option.closest('[data-aah-finish-picker]');
    if (!picker) return;
    setActiveLabel(picker, option.dataset.finishLabel || '');
  }
  function previewOff(event) {
    var option = event.target.closest('[data-aah-finish-option]');
    if (!option) return;
    var picker = option.closest('[data-aah-finish-picker]');
    if (!picker) return;
    setActiveLabel(picker, getSelectedLabel(picker));
  }
  document.addEventListener('mouseover', previewOn);
  document.addEventListener('mouseout',  previewOff);
  document.addEventListener('focusin',   previewOn);
  document.addEventListener('focusout',  previewOff);

  // Safety net on load — if for some reason nothing is .is-selected
  // (e.g., server-rendered without the default-select), pick the first.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-aah-finish-picker]').forEach(function (picker) {
      var hasSelected = picker.querySelector('[data-aah-finish-option].is-selected');
      if (!hasSelected) {
        var first = picker.querySelector('[data-aah-finish-option]');
        if (first) {
          first.classList.add('is-selected');
          first.setAttribute('aria-pressed', 'true');
          var label = first.dataset.finishLabel || '';
          picker.setAttribute('data-aah-selected-label', label);
          setActiveLabel(picker, label);
          var input = picker.querySelector('[data-aah-finish-input]');
          if (input) input.value = label;
        }
      }
    });
  });
})();
